import logo from './logo.svg';
import './App.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Link, Routes, Route } from "react-router-dom";
import Navigation from "./Navigation";
import Home from "./Home";
import Pack from "./Pack";
import Submit from "./Submit";
import Discord from "./Discord";
import Signin from "./Signin";
import Dashboard from "./Dashboard";
import User from "./User";
import Edit from "./Edit";
import Reset from "./Reset";
import Verify from "./Verify";
import Explore from "./Explore";

function App() {
  return (
    <BrowserRouter>
      <Navigation/>
      <Routes>
        <Route path="/pack/:packId" element={<Pack/>}/>
        <Route path="/discord" element={<Discord/>}/>
        <Route path="/submit" element={<Submit/>}/>
        <Route path="/explore" element={<Explore/>}/>
        <Route exact path="/" element={<Home/>}/>
      </Routes>
    </BrowserRouter>
  );
}

/*
<Route path="/pack/:packId" element={<Pack/>}/>
        <Route path="/edit/:packId" element={<Edit/>}/>
        <Route path="/user/:userId" element={<User/>}/>
        <Route path="/dashboard" element={<Dashboard/>}/>
        <Route path="/discord" element={<Discord/>}/>
        <Route path="/submit" element={<Submit/>}/>
        <Route path="/signin" element={<Signin/>}/>
        <Route path="/reset-password" element={<Reset/>}/>
        <Route path="/verify-email" element={<Verify/>}/>
        <Route path="/explore" element={<Explore/>}/>
        <Route exact path="/" element={<Home/>}/>
*/

export default App;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);